/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.pages

import japgolly.scalajs.react.extra.router.{Resolution, RouterCtl}
import japgolly.scalajs.react.vdom.html_<^._
import japgolly.scalajs.react.{Callback, _}
import net.scalytica.blaargh.components.{Footer, Menu}
import net.scalytica.blaargh.models.Config
import net.scalytica.blaargh.pages.Views.View
import org.scalajs.dom

import scala.concurrent.Future

import scala.scalajs.js.Dynamic

object PageLayout {

  case class Props(
      futureConf: Future[Config],
      ctl: RouterCtl[View],
      r: Resolution[View]
  )

  case class State(conf: Config)

  val AnimationStrenghts: Seq[Double] = Seq(5.0, 10.0, 20.0, 40.0, 80.0, 160.0)

  class Backend($ : BackendScope[Props, State]) {

    def animateLayers(e: ReactMouseEvent): Callback = {
      import dom.ext._
      import dom.{document, window}
      Callback {
        val layers = document.getElementsByClassName("layer").zipWithIndex
        layers.foreach { l =>
          val i       = if (l._2 >= layers.length) 0 else l._2
          val wWidth  = window.innerWidth
          val wHeight = window.innerHeight

          if (wWidth <= 600) {
            window.console.log("animation disabled due to window size")
          } else {
            val pageX: Double  = e.nativeEvent.clientX - (wWidth.toDouble / 2.0)
            val pageY: Double  = e.nativeEvent.clientY - (wHeight / 2.0)
            val transX: Double = AnimationStrenghts(i) / wWidth * pageX * -1.0
            val transY: Double = AnimationStrenghts(i) / wHeight * pageY * -1.0

            l._1.domAsHtml.style.transform =
              s"translateX(${transX}px) translateY(${transY}px)"
          }
        }
      }
    }

    def render(props: Props, state: State) = {
      <.div(^.key := "page-layout-1",
        ^.className := "app",
        ^.onMouseMove ==> animateLayers,
        Menu(state.conf, props.r.page, props.ctl),
        <.div(
          ^.key := "page-layout-1-1",
          ^.className := "background parallax"),
        props.r.render(),
        Footer(state.conf)
      )
    }
  }

  val component = ScalaComponent
    .builder[Props]("PageLayout")
    .initialStateFromProps(_ => State(Config.empty))
    .renderBackend[Backend]
    .build

  def apply(conf: Future[Config], ctl: RouterCtl[View], r: Resolution[View]) =
    component(Props(conf, ctl, r))

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/pages/PageLayout.scala